import React from 'react'

const HomeMDMessage = () => {
    return (
        <>

            <div className="skill-area" style={{marginTop:"20px"}}>
                <div className="container">
                    <div className="skill-wrap">
                        <div className="row g-4 align-items-center">
                            <div className="col-lg-6">
                                <div className="skill-img wow fadeInLeft" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInLeft' }}>
                                    <img src="assets/yog/Yogesh.webp" alt="thumb" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="skill-content wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                    <span className="site-title-tagline"><i className="far fa-solar-panel" /> Proprietor</span>
                                    <h2 className="site-title">Yogesh <span>Solar</span> Energy</h2>
                                    <p className="skill-text">
                                        At Yogesh Solar Energy, our vision is simple yet powerful — to create a sustainable future powered by clean and renewable energy.

                                    </p>
                                    <p className="skill-text" style={{textAlign:"justify"}}>
                                        In today’s rapidly evolving world, energy demands are increasing, and so is our responsibility toward the environment. We believe that solar energy is not just an alternative, but a necessity for a greener and more secure tomorrow. Our mission is to make solar power accessible, affordable, and efficient for every home, business, and industry.
                                    </p>
                                    
                                    <div className="skill-progress">
                                    </div>
                                    <div className="progress-item">
                                        <h5>Mr. Yogesh Kushwaha <span className="percent"></span></h5>
                                        <p>Proprietor</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default HomeMDMessage